import styled from "@emotion/styled/macro";
import { Box, Typography } from "@mui/material";
import theme from "../theme";

export const MessagePanelBannerContainer = styled(Box)`
  position: absolute;
  top: 0;
  width: 100%;
  background-color: ${theme.palette.primary.main};
  text-align: center;
  z-index: 1;
`;

export const MessagePanelBannerMessage = styled(Typography)`
  color: ${theme.palette.common.white};
  font-size: 12px;
`;
